export const COLUMN_ID = 'id';
export const COLUMN_PREVIEW = 'preview';
export const COLUMN_NAME = 'name';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_DOMAIN = 'domain';
export const COLUMN_LOCALES = 'locales';
export const COLUMN_FLOW = 'conversionPageFlow';
export const COLUMN_TAGS = 'tags';
